import { useDispatch, useSelector } from 'react-redux';
import { push } from 'redux-first-history';

import { BUTTON_SIZES, DestructiveButton } from 'ui/button';
import { Modal, ModalFooter, ModalHeader, ModalBody, MODAL_SIZES, MODAL_VARIANTS } from 'ui/modal';
import { useDeleteDraft } from 'modules/workflows/hooks';

import { closeModal, fetchWorkflowRequest, getWorkflow } from '../../../ducks';
import { DELETE_DRAFT_MODAL } from '../../../constants';

export const DELETE_DRAFT_BUTTON_TEST_ID = 'delete-draft-button';

interface DeleteDraftModalProps {
  /** Whether the modal is open */
  isOpen: boolean;
}

export const DeleteDraftModal = ({ isOpen }: DeleteDraftModalProps) => {
  const dispatch = useDispatch();
  const deleteDraft = useDeleteDraft();
  const workflow = useSelector(getWorkflow);

  const handleCloseModal = () => dispatch(closeModal(DELETE_DRAFT_MODAL));

  const handleDeleteDraft = () => {
    const { workflowReference } = workflow;

    deleteDraft({
      variables: {
        id: workflow.id,
      },
      onSuccess: () => {
        if (workflowReference) {
          dispatch(fetchWorkflowRequest(workflowReference.id, workflowReference.workflowType));
        } else {
          dispatch(push('/workflows'));
        }
      },
    });

    handleCloseModal();
  };

  return (
    <Modal
      id={DELETE_DRAFT_MODAL}
      isModalOpen={isOpen}
      onClose={handleCloseModal}
      size={MODAL_SIZES.SMALL}
      variant={MODAL_VARIANTS.DELETE}
    >
      <ModalHeader>Delete draft? </ModalHeader>
      <ModalBody>
        <p>This will completely delete your draft, and you won&apos;t be able to recover it.</p>
        <p>(You&apos;ll need to create a new draft if you want to edit the published journey.)</p>
      </ModalBody>
      <ModalFooter>
        <DestructiveButton
          data-test={DELETE_DRAFT_BUTTON_TEST_ID}
          onClick={handleDeleteDraft}
          size={BUTTON_SIZES.LARGE}
        >
          Delete draft
        </DestructiveButton>
      </ModalFooter>
    </Modal>
  );
};
